export default {
	edit: 'संपादित करें',
	delete: 'हटाएँ',
	enable: 'इस परिदृश्य के लिए सक्षम करें',
	disable: 'इस परिदृश्य के लिए अक्षम करें',
	next_step: 'अगला चरण',
	skip: 'छोड़ें',
	finish_review: 'समीक्षा पूर्ण करें',
	skip_review: 'समीक्षा छोड़ें',
	view: 'विवरण देखें',
	close: 'बंद करें',
	cancel: 'रद्द करें',
	send: 'भेजें',
	clone: 'क्लोन',
	open: 'खोलें',
	sign_out: 'लॉग आउट',
	search: 'खोजें',
	save: 'सहेजें',
	sort_by_name: 'नाम से क्रमबद्ध करें (A→Z)',
	sort_by_importance: 'महत्व से क्रमबद्ध करें (उच्च→निम्न)',
	filter_positive: 'सकारात्मक हितधारकों को फ़िल्टर करें',
	filter_negative: 'नकारात्मक हितधारकों को फ़िल्टर करें',
	export: {
		excel: 'Excel के रूप में निर्यात करें',
		image: 'दृश्य को छवि के रूप में निर्यात करें'
	},
	click_to_select: 'चुनने के लिए क्लिक करें',
	click_to_drag: 'खींचकर ले जाएँ',
	confirm_drop: {
		message_baseline:
			'आप बेसलाइन अपडेट कर रहे हैं, क्या आप परिवर्तनों की पुष्टि करते हैं?',
		message_scenario:
			'आप परिदृश्य {{scenarioName}} अपडेट कर रहे हैं, क्या आप पुष्टि करते हैं?',
		likelihood: 'संभावना',
		impact: 'प्रभाव',
		before: 'पहले',
		after: 'बाद'
	}
};
